  // Return a string for the image's srcSet value
export const getSrcSet = (url: string, sizes: number[]): string => {
    const srcset = sizes
      .map((size) => `${url.replace('?as=0&w=2048', '')}?as=0&w=${size * 2} ${size * 2}w`)
      .join(", ");
    return srcset;
  };